import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'
import { Box } from '@mui/system'
import CourseCard from '../../../components/CourseCard'
import Breadcrumb from '../../../components/Breadcrumb'
import { UserCourseState } from '../../../features/types'
import { courseApiSlice } from '../../../features/course/courseSlice'

const TeacherCoursesPage = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { data: courses = [], isFetching: isFetchingCourses } =
        courseApiSlice.useFetchAllUserCoursesQuery()

    const handleNavigate = (course: UserCourseState) => {
        navigate(`/teacher-courses/subjects`, {
            state: { course: course },
        })
    }
    return (
        <Wrapper>
            <Breadcrumb links={[formatMessage({ id: 'myCourses' })]} />

            <Content>
                <Box sx={{ display: 'flex' }}>
                    {isFetchingCourses ? (
                        <CircularProgress />
                    ) : courses.length ? (
                        courses.map((course) => (
                            <CourseCard
                                key={course.courseId}
                                course={course}
                                onNavigate={handleNavigate}
                            />
                        ))
                    ) : (
                        formatMessage({ id: 'noData' })
                    )}
                </Box>
            </Content>
        </Wrapper>
    )
}

export default TeacherCoursesPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
